import { SendTestEmailDto } from "../generated/schema.ts";
import { useApiMutation } from "./use-api-mutation";

export default function useSendTrackingTestEmail(shopId: string) {
  return useApiMutation(
    "post",
    "/shops/{shopId}/email-templates/send-test",
    {
      notify: false,
      meta: {
        success: {
          title: "Email de test envoyé avec succès",
          message: "Vérifiez votre boite mail, vous devriez l'avoir reçu",
        },
        error: {
          title: "Une erreur est survenue lors de l'envoi de l'email de test",
          message: "Veuillez vérifier les informations envoyées et réessayer.",
        },
      },
      mapVariables: ({ requestBody }: { requestBody: SendTestEmailDto }) => ({
        params: { path: { shopId } },
        body: requestBody,
      }),
    },
  );
}
